import { render } from "./CxRelatedEntitiesBadge.vue?vue&type=template&id=0771d37a"
import script from "./CxRelatedEntitiesBadge.vue?vue&type=script&lang=js"
export * from "./CxRelatedEntitiesBadge.vue?vue&type=script&lang=js"

import "./CxRelatedEntitiesBadge.vue?vue&type=style&index=0&id=0771d37a&lang=less"

import exportComponent from "/home/ec2-user/workspace/_conx-ui-monorepo_ui2_lab_master/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__